import GlobalLoader from './GlobalLoader.vue';

export default {
  install(Vue) {
    Vue.component('GlobalLoader', GlobalLoader);
    Vue.mixin({
      methods: {
        showGlobalLoader(msg) {
          this.$nextTick(() => {
            this.$root.$emit('show-global-loader', msg);
          });
        },
        hideGlobalLoader() {
          this.$root.$emit('hide-global-loader');
        },
      },
    });
  },
};
